interface Room { id: string; name: string }
interface BookingWindow {
  id: string;
  room_id: string;
  arrival_date: string;
  departure_date: string;
}

interface Props {
  rooms: Room[];
  bookings: BookingWindow[];
  dates: string[];
  onPrevious: () => void;
  onNext: () => void;
}

function shortDate(date: string) {
  const [, month, day] = date.split('-');
  return `${Number(month)}/${Number(day)}`;
}

export default function OccupancyChart({ rooms, bookings, dates, onPrevious, onNext }: Props) {
  return (
    <div className="rounded-md border overflow-hidden h-full" style={{ backgroundColor: '#FFFEFA', borderColor: '#DED9CC' }}>
      <div className="px-2 py-1.5 flex items-center justify-between" style={{ borderBottom: '1px solid #DED9CC' }}>
        <button onClick={onPrevious} className="w-6 h-6 rounded flex items-center justify-center cursor-pointer" aria-label="前の14日間" style={{ color: '#234638', backgroundColor: '#F0EDE5' }}><i className="ri-arrow-left-s-line" /></button>
        <div className="text-center"><h3 className="text-xs font-semibold" style={{ color: '#252824' }}>部屋別予約状況（14日間）</h3>{dates.length > 0 && <p className="text-[10px] mt-0.5" style={{ color: '#6B6B67' }}>{shortDate(dates[0])} — {shortDate(dates[dates.length - 1])}</p>}</div>
        <button onClick={onNext} className="w-6 h-6 rounded flex items-center justify-center cursor-pointer" aria-label="次の14日間" style={{ color: '#234638', backgroundColor: '#F0EDE5' }}><i className="ri-arrow-right-s-line" /></button>
      </div>
      <div className="overflow-hidden px-2 py-1.5">
        <div className="min-w-0 grid gap-y-px" style={{ gridTemplateColumns: '30px repeat(14, minmax(0, 1fr))' }}>
          <div />
          {dates.map((date) => <div key={date} className="text-center text-[10px] font-medium pb-1" style={{ color: '#6B6B67' }}>{shortDate(date)}</div>)}
          {rooms.map((room) => {
            const roomBookings = bookings.filter((booking) => booking.room_id === room.id);
            return <div key={room.id} className="contents">
              <div className="flex items-center text-[10px] font-bold pr-1" style={{ color: '#252824' }}>{room.name.replace(/^Room\s*/i, '')}</div>
              {dates.map((date) => {
                const occupied = roomBookings.some((booking) => booking.arrival_date <= date && booking.departure_date > date);
                const isIn = roomBookings.some((booking) => booking.arrival_date === date);
                const isOut = roomBookings.some((booking) => booking.departure_date === date);
                return <div key={`${room.id}-${date}`} className="h-5 overflow-hidden relative flex items-center justify-center border-y border-white/70" style={{ backgroundColor: occupied ? '#234638' : '#F0EDE5', color: occupied ? '#FFFEFA' : '#6B6B67' }} title={`${room.name} ${shortDate(date)}${isOut ? ' OUT' : ''}${isIn ? ' IN' : ''}`}>
                  <div className="flex items-center gap-px text-[7px] font-bold leading-none">
                    {isOut && <span className="rounded px-0.5 py-0.5" style={{ backgroundColor: '#A8843A', color: '#FFFEFA' }}>OUT</span>}
                    {isIn && <span className="rounded px-0.5 py-0.5" style={{ backgroundColor: occupied ? '#FFFEFA' : '#234638', color: occupied ? '#234638' : '#FFFEFA' }}>IN</span>}
                  </div>
                </div>;
              })}
            </div>;
          })}
        </div>
        <div className="flex items-center gap-4 mt-1 text-[9px]" style={{ color: '#6B6B67' }}><span className="flex items-center gap-1"><i className="w-2 h-2 rounded-sm bg-[#234638]" />宿泊中</span><span className="flex items-center gap-1"><i className="w-2 h-2 rounded-sm bg-[#A8843A]" />OUT</span></div>
      </div>
    </div>
  );
}
